import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { DiscountsRouteNames, DiscountsRoutePathNames } from '../../enums';
import { beforeEnter } from '../../routes/guards/index';
import locationUserManagementRoute from './components/ryst-location-user-management';
import promoManagementRoute from './components/ryst-promo-management';

export default {
  path: buildChildURL(DiscountsRoutePathNames.RYST_INCENTIVES_MANAGER),
  name: DiscountsRouteNames.RYST_INCENTIVES_MANAGER,
  redirect: { name: DiscountsRouteNames.RYST_PROMO_MANAGEMENT },
  beforeEnter,
  children: [locationUserManagementRoute, promoManagementRoute],
} as RouteRecordRaw;

export { default as locationUserManagementRoute } from './components/ryst-location-user-management';
export { default as promoManagementRoute } from './components/ryst-promo-management';
